var _excluded = ["direction", "style", "children", "unmountOnExit", "in", "className", "duration"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as React from 'react';
import { Transition } from 'react-transition-group';
import { tqc } from '../../system';
import { cx, isFunction, __DEV__ } from '../../utils';
var defaultOptions = {
  duration: 200,
  direction: 'left'
};
var getSharedStyles = function getSharedStyles() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var {
    duration = defaultOptions.duration,
    direction
  } = options;
  var styles = {
    left: {
      width: '100%',
      left: 0,
      top: 0,
      bottom: 0
    },
    right: {
      width: '100%',
      right: 0,
      top: 0,
      bottom: 0
    },
    top: {
      maxWidth: '100vw',
      left: 0,
      top: 0,
      right: 0
    },
    bottom: {
      maxWidth: '100vw',
      left: 0,
      right: 0,
      bottom: 0
    }
  };
  return _objectSpread({
    transform: 'translateX(-100%)',
    transitionProperty: 'all',
    transitionTimingFunction: 'ease',
    transitionDuration: "".concat(duration, "ms"),
    position: 'fixed'
  }, styles[direction]);
};
var getStyles = function getStyles(status) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  return _objectSpread(_objectSpread({}, getSharedStyles(options)), directions[options.direction][status]);
};
export var getSlideStyles = getStyles;
export var getSlideSharedStyles = getSharedStyles;
var directions = {
  left: {
    entering: {
      transform: 'translateX(0)'
    },
    entered: {
      transform: 'translateX(0)'
    },
    exiting: {
      transform: 'translateX(-100%)'
    },
    exited: {
      transform: 'translateX(-100%)'
    }
  },
  right: {
    entering: {
      transform: 'translateX(0)'
    },
    entered: {
      transform: 'translateX(0)'
    },
    exiting: {
      transform: 'translateX(100%)'
    },
    exited: {
      transform: 'translateX(100%)'
    }
  },
  bottom: {
    entering: {
      transform: 'translateY(0)'
    },
    entered: {
      transform: 'translateY(0)'
    },
    exiting: {
      transform: 'translateY(100%)'
    },
    exited: {
      transform: 'translateY(100%)'
    }
  },
  top: {
    entering: {
      transform: 'translateY(0)'
    },
    entered: {
      transform: 'translateY(0)'
    },
    exiting: {
      transform: 'translateY(-100%)'
    },
    exited: {
      transform: 'translateY(-100%)'
    }
  }
};
export var Slide = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      direction = 'left',
      style,
      children,
      unmountOnExit = true,
      in: isOpen,
      className,
      duration = 200
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Transition, {
    in: isOpen,
    unmountOnExit: unmountOnExit,
    timeout: duration
  }, isFunction(children) ? status => children({
    transitionStyles: getStyles(status, {
      direction,
      duration
    }),
    transitionStatus: status
  }) : status => /*#__PURE__*/React.createElement(tqc.div, _extends({
    ref: ref,
    className: cx('tqc-slide', className),
    style: _objectSpread(_objectSpread({
      position: 'fixed'
    }, getStyles(status, {
      direction,
      duration
    })), style)
  }, rest), children));
});
if (__DEV__) {
  Slide.displayName = 'Slide';
}